import { getStartInfo } from "./start-info";
let storedCommands = {};
export function getAll() {
    return storedCommands;
}
export function get(id) {
    return storedCommands[id] || null;
}
export function getIds() {
    return Object.keys(storedCommands);
}
export function add(commands) {
    const { logger } = getStartInfo();
    const storedCommands = getAll();
    for (const command of commands) {
        if (typeof storedCommands[command.ipm_id] !== "undefined") {
            logger.debug("[ipm]: Campaign already stored:", command.ipm_id);
            continue;
        }
        storedCommands[command.ipm_id] = command;
    }
}
export function remove(id) {
    const command = get(id);
    if (!command) {
        return;
    }
    delete storedCommands[command.ipm_id];
}
export function replaceAll(commandMap) {
    storedCommands = { ...commandMap };
}
